<template>
  <div class="account-detail-page">
    <div class="page-header">
      <a-page-header title="账单信息" :ghost="true">
        <template slot="extra">
          <a-button
            type="primary"
            @click="() => $router.push({ path: '/app/signing/tenantaccount' })"
          >
            返 回
          </a-button>
        </template>
        <a-descriptions size="small" :column="3">
          <a-descriptions-item>
            <i class="iconfont icon-icon-user"></i>
            <div>租户名称：{{ accountObj.tenatName || "--" }}</div>
          </a-descriptions-item>
          <a-descriptions-item>
            <i class="iconfont icon-icon--"></i>
            <div>账单类型：{{ accountObj.a || "--" }}</div>
          </a-descriptions-item>
          <a-descriptions-item>
            <i class="iconfont icon-shouji"></i>
            <div>联系方式：{{ accountObj.contactPhone || "--" }}</div>
          </a-descriptions-item>
          <a-descriptions-item>
            <i class="iconfont icon-shijian"></i>
            <div>创建时间：{{ accountObj.dateCreated || "--" }}</div>
          </a-descriptions-item>
          <a-descriptions-item>
            <i class="iconfont icon-jiesuanguanli"></i>
            <div>结算开始时间：{{ preDate || "--" }}</div>
          </a-descriptions-item>
          <a-descriptions-item>
            <i class="iconfont icon-jiesuanguanli"></i>
            <div>结算结束时间：{{ endDate || "--" }}</div>
          </a-descriptions-item>
        </a-descriptions>
      </a-page-header>
    </div>
    <div class="table" id="table">
      <div class="titl-excel">
        <div class="title">
          <div class="line"></div>
          <div>账单管理-日明细</div>
        </div>
        <a-button type="primary" @click="onDayExport">导出Excel</a-button>
      </div>
      <a-table
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="pagination"
        @change="(pagination) => getDeductionDetail(pagination.current - 1)"
      >
        <template slot="operation" slot-scope="record">
          <div class="handle">
            <a-tooltip title="查看明细">
              <div class="icon" @click="openModal(record)">
                <i class="iconfont icon-chakan" />
              </div>
            </a-tooltip>
            <!-- <a-tag color="blue" class="view" @click="openModal(record)"
              >查看明细</a-tag
            > -->
          </div>
        </template>
      </a-table>
    </div>
    <a-modal
      class="account-modal"
      width="1000px"
      title="账单明细"
      :visible="visible"
      :maskClosable="false"
      :footer="null"
      @cancel="handleClose"
    >
      <a-button style="margin-bottom: 20px" type="primary" @click="onExport"
        >导出Excel</a-button
      >
      <a-table
        rowKey="id"
        :columns="modalColumns"
        :dataSource="modalDataSource"
        :pagination="modalPagination"
      />
    </a-modal>
  </div>
</template>
<script>
import { contractWalletUseFlowPage, deviceDaySettPage } from "../service";
import { domainStr } from "../../../../utils/request";
import scrollbarInit from "../../../../utils/perfectScrollBar";
const columns = [
  {
    title: "结算开始时间",
    dataIndex: "preDate",
    customRender: (text) => {
      return text || "--";
    },
  },
  {
    title: "结算结束时间",
    dataIndex: "endDate",
    customRender: (text) => {
      return text || "--";
    },
  },
  {
    title: "费用",
    dataIndex: "useNumber",
    customRender: (text) => {
      return text || "0";
    },
  },
  { title: "操作", dataIndex: "", scopedSlots: { customRender: "operation" } },
];
const modalColumns = [
  {
    title: "日期",
    dataIndex: "dateCreated",
    customRender: (text) => {
      return text || "--";
    },
  },
  {
    title: "设备类型",
    dataIndex: "productType",
    customRender: (text) => {
      const types = {
        ELECTRIC: "电表",
        WATER: "水表",
        COLD_WATER: "冷水表",
        HOT_WATER: "热水表",
        GAS: "燃气表",
        OTHER: "其他",
      };
      return types[text] || "--";
    },
  },
  {
    title: "设备名称",
    dataIndex: "deviceName",
    customRender: (text) => {
      return text || "--";
    },
  },
  {
    title: "起始读数",
    dataIndex: "preGraduation",
    customRender: (text) => {
      return text || "0";
    },
  },
  {
    title: "结算读数",
    dataIndex: "afterGraduation",
    customRender: (text) => {
      return text || "0";
    },
  },
  {
    title: "读数差",
    dataIndex: "dayUsed",
    customRender: (text) => {
      return text || "0";
    },
  },
  {
    title: "倍率",
    dataIndex: "baseNumber",
    customRender: (text) => {
      return text || "0";
    },
  },
  {
    title: "设备单价",
    dataIndex: "unitPrice",
    customRender: (text) => {
      return text || "0";
    },
  },
  {
    title: "费用",
    dataIndex: "cost",
    customRender: (text) => {
      return text || "0";
    },
  },
];
export default {
  data() {
    return {
      accountObj: {},
      columns,
      dataSource: [],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
      },

      visible: false,
      modalRecord: {},
      modalColumns,
      modalDataSource: [],
      modalPagination: {
        current: 1,
        pageSize: 10,
        total: 0,
      },
    };
  },
  created() {
    let accountObj = JSON.parse(this.$route.query.accounts);
    this.accountObj = accountObj;
    this.getDeductionDetail();
  },
  computed: {
    preDate() {
      return this.$moment(this.accountObj.preDate).format("YYYY-MM-DD");
    },
    endDate() {
      return this.$moment(this.accountObj.endDate).format("YYYY-MM-DD");
    },
  },
  mounted() {
    this.createScroll();
  },
  methods: {
    createScroll() {
      const scrollBar = scrollbarInit("#table");
      const dom = document.querySelector("#table");
      dom.scrollTop = 0;
      scrollBar.update();
    },
    openModal(record) {
      console.log(record);
      this.modalRecord = record;
      this.visible = true;
      this.getAccountDay();
    },
    handleClose() {
      this.visible = false;
      this.modalRecord = {};
      this.modalDataSource = [];
      this.modalPagination = {
        current: 1,
        pageSize: 10,
        total: 0,
      };
    },
    async getDeductionDetail(pageNo = 0) {
      try {
        const params = {
          contractBillId: this.accountObj.id,
          pageNo,
          pageSize: 10,
        };

        const res = await contractWalletUseFlowPage.request(params, {
          showBizRemind: true,
        });

        if (res.bizCode === 1) {
          this.dataSource = res.data.items;
          this.pagination = {
            current: res.data.pageNo + 1,
            pageSize: 10,
            total: res.data.totalCount,
          };
        }
      } catch (err) {
        console.error(err);
      }
    },
    async getAccountDay(pageNo = 0) {
      try {
        const params = {
          flowId: this.modalRecord.id,
          pageNo,
          pageSize: 10,
        };

        const res = await deviceDaySettPage.request(params, {
          showBizRemind: true,
        });

        if (res.bizCode === 1) {
          this.modalDataSource = res.data.items;
          this.modalPagination = {
            current: res.data.pageNo + 1,
            pageSize: 10,
            total: res.data.totalCount,
          };
        }
      } catch (err) {
        console.error(err);
      }
    },
    async onDayExport() {
      try {
        let url = `${domainStr}/v2/device/day/settlement/export?contractBillId=${this.accountObj.id}`;

        const a = document.createElement("a");
        a.href = url;
        a.download = "账单日明细.xlsx";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      } catch (err) {
        console.error(err);
      }
    },
    async onExport() {
      try {
        let url = `${domainStr}/v2/contract/wallet/use/flow/export?flowId=${this.modalRecord.id}`;

        const a = document.createElement("a");
        a.href = url;
        a.download = "账单明细.xlsx";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      } catch (err) {
        console.error(err);
      }
    },
  },
};
</script>
<style lang="less" scoped>
@import "../../../../utils/convertPxToDesighViewport/convertPxToDesighViewport";
//.convertPxToDesighVH(20)[] .convertPxToDesighVW(20)[]
.account-detail-page {
  width: 100%;
  overflow: hidden;
  > .page-header {
    background: #192430;
    border: .convertPxToDesighVH(2) [] solid #293646;
    border-radius: .convertPxToDesighVH(10) [];
    height: .convertPxToDesighVH(220) [];
    > .ant-page-header {
      background: transparent;
      height: .convertPxToDesighVH(220) [];
      box-sizing: border-box;
      border-radius: .convertPxToDesighVH(10) [];
    }
  }
  > .table {
    padding: .convertPxToDesighVH(20) [];
    margin-top: .convertPxToDesighVH(20) [];
    background: #192430;
    border: .convertPxToDesighVH(2) [] solid #293646;
    border-radius: .convertPxToDesighVH(10) [];
    // overflow: auto;
    height: calc(100vh - .convertPxToDesighVH(350) []);
    > .titl-excel {
      height: .convertPxToDesighVH(64) [];
      background: transparent;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0px .convertPxToDesighVW(20) [];
      margin-bottom: .convertPxToDesighVH(20) [];
      .title {
        display: flex;
        align-items: center;
        .line {
          margin-right: .convertPxToDesighVW(8) [];
          width: .convertPxToDesighVW(4) [];
          height: .convertPxToDesighVH(16) [];
          background: #0f9f64;
          border-radius: .convertPxToDesighVH(4) [];
        }
        div {
          font-size: .convertPxToDesighVH(16) [];
          font-family: Microsoft YaHei;
          font-weight: 400;
          line-height: .convertPxToDesighVH(21) [];
          color: #e2f2ff;
        }
      }
    }
    > .ant-table-wrapper {
      .handle {
        display: flex;
        .icon {
          width: .convertPxToDesighVW(40) [];
          height: .convertPxToDesighVH(40) [];
          background: #091121;
          border-radius: .convertPxToDesighVH(15) [];
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: .convertPxToDesighVW(24) [];
        }
        > .ant-tag {
          height: .convertPxToDesighVH(30) [];
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: .convertPxToDesighVH(14) [];
          font-family: Microsoft YaHei;
          font-weight: 300;
          margin-right: .convertPxToDesighVW(20) [];
        }
      }
    }
  }
}

#table {
  position: relative;
  overflow: hidden;
}
</style>
